import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Store } from '@ngrx/store';

import { selectUser } from '../../../../store/app.selectors';

import { MessagingEnvironmentService } from '../../../../core/services/messaging-environment.service';
import { IUserProfile } from '../../../user/interfaces/IUserProfile';
import { AppStateWithChat } from '../../store/chat.reducer';

@Injectable()
export class ContactDirectoryService {
  profileInfo: IUserProfile | null = null;
  constructor(
    private httpClient: HttpClient,
    private store: Store<AppStateWithChat>,
    private env: MessagingEnvironmentService
  ) {
    this.store.select(selectUser).subscribe((user) => {
      this.profileInfo = user;
    });
  }

  notifyVideoCallMembers(membersId: string[], roomUID: string): Observable<unknown> {
    const params: Record<string, string> = {
      'account-uid': this.profileInfo?.subAccountMessageableEntity?.accountUID ?? '',
    };
    const userIds = membersId.map((memberId) => Number(memberId));
    const body = {
      userIds,
      title: `${this.profileInfo?.subjectMessageableEntity?.displayName ?? ''} is calling you`,
      body: 'Pick up the phone',
      customFields: {
        roomId: roomUID,
        nameCaller: this.profileInfo?.subjectMessageableEntity?.displayName ?? '',
        type: 'VOICE_CALL',
      },
    };
    return this.httpClient.post<unknown>(`${this.env.env.contactDirectoryApi}/voice-call/notify-participants`, body, {
      params,
    });
  }
}
